module.exports = require("./ne-IN.js");